import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Materiais',
  path: '/merenda/mertipomaterial',
  name: 'mertipomaterial',
  component: () => import('@/views/merenda/mertipomaterial/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMATERIAISNOVO_MENU_1900500299],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Materiais',
  path: '/merenda/mertipomaterial/cadastro/:id?',
  parent: 'mertipomaterial',
  name: 'mertipomaterial_create',
  component: () => import('@/views/merenda/mertipomaterial/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEMATERIAISNOVO_MENU_1900500299],
  },
  goesToMenu: true,
 },
]
